export default {
  head: {
    title: 'Customer Enrollment operations billing',
    action: {
      create: {
        tooltip: 'Create new Customer Enrollment report'
      },
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Customer Enrollment billing operation'
    },
    details: {
      title: 'Operation details'
    }
  }
};
